const content = {
    maintenanceTitle: "SİTEMİZ BAKIMDADIR.",
};

module.exports = content;